import gql from "graphql-tag";

export const GET_ACTIVITY = gql`
    query Activity($activityId: ID!){
        activity(activityId: $activityId) {
            activityId
            userId
            parentType
            parentId
            shareCategoryType
            shareCategoryId
            activityName
            activityDescription
            activityType
            activityStatus
            activityData
            startedAt
            endedAt
            createdAt
            updatedAt
            deleted
            deletedAt
            account {
                accountId
                accountName
            }
            contact {
                contactId
                contactSalutation
                contactFirstName
                contactMiddleName
                contactLastName
                contactSuffix
                contactNickName
            }
            project {
                projectId
                projectName
                projectDescription
                projectStatus
                projectPriority
                startAt
                endAt
            }
            team {
                teamId
                teamName
            }
            integration {
                integrationId
                integrationName
            }
        }
    }
`;

export const GET_ACTIVITIES = gql`
    query Activities($parentType: String, $parentId: ID, $shareCategoryType: String, $shareCategoryId: ID, $searchStr: String, $limit: Int, $offset: Int, $showCompleted: Boolean, $showDeleted: Boolean, $orderList: [String]){
        activities(parentType: $parentType, parentId: $parentId, shareCategoryType: $shareCategoryType, shareCategoryId: $shareCategoryId, searchStr: $searchStr, limit: $limit, offset: $offset, showCompleted: $showCompleted, showDeleted: $showDeleted, orderList: $orderList) {
            activityId
            userId
            parentType
            parentId
            shareCategoryType
            shareCategoryId
            activityName
            activityDescription
            activityType
            activityStatus
            activityData
            startedAt
            endedAt
            createdAt
            updatedAt
            deleted
            deletedAt
            account {
                accountId
                accountName
            }
            contact {
                contactId
                contactSalutation
                contactFirstName
                contactMiddleName
                contactLastName
                contactSuffix
                contactNickName
            }
            project {
                projectId
                projectName
                projectDescription
                projectStatus
                projectPriority
                startAt
                endAt
            }
            team {
                teamId
                teamName
            }
            integration {
                integrationId
                integrationName
            }
        }
    }
`;

export const CREATE_ACTIVITY = gql`
    mutation CreateActivity($newActivity: newActivity!) {
        createActivity(
            newActivity: $newActivity
        ) {
            returnCode
            message
            id
            name
        }
    }
`;

export const UPDATE_ACTIVITY = gql`
    mutation UpdateActivity($changedActivity: changedActivity!) {
        updateActivity(
            changedActivity: $changedActivity
        ) {
            returnCode
            message
        }
    }
`;

export const DELETE_ACTIVITY = gql`
    mutation DeleteActivity($deleteActivityId: ID!) {
        deleteActivity(
            deleteActivityId: $deleteActivityId
        ) {
            returnCode
            message
        }
    }
`;

export const DELETE_ACTIVITIES = gql`
    mutation DeleteActivities($deleteActivityIds: [ID!]!) {
        deleteActivities(
            deleteActivityIds: $deleteActivityIds
        ) {
            returnCode
            message
        }
    }
`;
